"use client";

import { MAX_UNREAD_COUNT } from "@/constants";

import { cn } from "@/lib/utils";
import { clamp, motion } from "motion/react";
import { Badge } from "./ui/badge";

interface Props {
  readonly count: number | boolean;
  readonly className?: string;
  readonly badgeClassName?: string;
}

export function UnreadCount(props: Props) {
  const isNumber = typeof props.count === "number";

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      exit={{ scale: 0 }}
      className={cn("absolute right-3.5 top-1.5", props.className)}
    >
      <Badge
        className={cn(
          "pulse-border z-10 flex size-4 animate-pulse justify-center rounded-full p-1 text-xs",
          props.badgeClassName,
        )}
        variant={
          isNumber && props.count > MAX_UNREAD_COUNT ? "destructive" : "warning"
        }
      >
        {isNumber ? clamp(props.count, MAX_UNREAD_COUNT, 1) : ""}
      </Badge>
    </motion.div>
  );
}
